import React, { useEffect, useState } from "react";
import axios from "axios";
import DeliveryLocationModal from "./DeliveryLocationModal";
import { useAuth } from "../Context/AuthContext";

const AddressComponent = () => {
  const { user, token } = useAuth();

  const emptyForm = {
    fullName: "",
    mobileNumber: "",
    pincode: "",
    flatHouse: "",
    streetArea: "",
    landmark: "",
    city: "",
    state: "",
    country: "India",
    email: "",
  };

  const [formData, setFormData] = useState(emptyForm);
  const [addresses, setAddresses] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [showModal, setShowModal] = useState(false);

  /* ================= AUTO USER ================= */
  useEffect(() => {
    if (user) {
      setFormData((prev) => ({
        ...prev,
        fullName: user.name || "",
        email: user.email || "",
      }));
    }
  }, [user]);

  /* ================= LOAD SELECTED ADDRESS ================= */
  // useEffect(() => {
  //   const saved = localStorage.getItem("selectedAddress");
  //   if (saved) {
  //     setSelectedAddress(JSON.parse(saved));
  //   }
  // }, []);

  /* ================= FETCH ADDRESSES ================= */
  const fetchAddresses = async () => {
    try {
      const res = await axios.get(
        "http://localhost:8500/api/v1/getmyaddresses",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setAddresses(res.data.addresses || []);
    } catch (err) {
      console.log("Error fetching address");
    }
  };

  useEffect(() => {
    if (token) fetchAddresses();
  }, [token]);

  /* ================= SELECT ADDRESS ================= */
  const handleSelectAddress = (addr) => {
    setSelectedAddress(addr);
    localStorage.setItem("selectedAddress", JSON.stringify(addr));
  };

  /* ================= DELETE ================= */
  const handleDelete = async (id) => {
    try {
      await axios.delete(
        `http://localhost:8500/api/v1/deleteaddress/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      alert("Address Deleted 🗑️");
      fetchAddresses();
    } catch (err) {
      alert("Delete failed ❌");
    }
  };

  /* ================= MAP SELECT ================= */
  const handleLocationSelect = (data) => {
    setShowForm(true);

    const parts = data.address.split(",");
    const city = parts[parts.length - 3]?.trim();
    const state = parts[parts.length - 2]?.trim();

    setFormData((prev) => ({
      ...prev,
      streetArea: data.address,
      pincode: data.pincode,
      city: city || "",
      state: state || "",
    }));
  };

  /* ================= SAVE ================= */
  const handleSubmit = async () => {
    try {
      await axios.post(
        "http://localhost:8500/api/v1/addshipping",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      alert("Address Saved ✅");
      setShowForm(false);
      setFormData(emptyForm);
      fetchAddresses();
    } catch (err) {
      alert("Save failed ❌");
    }
  };

  return (
    <div className="min-h-screen">
  <div className="max-w-5xl ">

    <div className="bg-white rounded-2xl  p-3">

      {/* HEADER */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6 gap-3">
        <h2 className="text-xl font-semibold text-gray-800">
          My Address
        </h2>

        <div className="flex gap-3">
          <button
            onClick={() => setShowModal(true)}
            className="bg-teal-600 text-white px-4 py-2 rounded-lg text-sm hover:bg-teal-700 transition shadow"
          >
            📍 Select from Map
          </button>

          <button
            onClick={() => {
              setShowForm(true);
              setFormData(emptyForm);
            }}
            className="bg-gray-100 px-4 py-2 rounded-lg text-sm hover:bg-gray-200 transition"
          >
            ✍️ Enter Manually
          </button>
        </div>
      </div>

      {/* ADDRESS LIST */}
      {addresses.length > 0 && (
        <div className="mb-6">
          
          <div className="space-y-4">
            {addresses.map((addr) => (
              <div
                key={addr._id}
                onClick={() => handleSelectAddress(addr)}
                className={`
                  border rounded-xl p-4 cursor-pointer
                  transition flex justify-between items-start
                  ${
                    selectedAddress?._id === addr._id
                      ? "border-teal-500 bg-teal-50 shadow-sm"
                      : "hover:border-gray-300"
                  }
                `}
              >
                {/* LEFT */}
                <div className="flex gap-3">
                  <input
                    type="radio"
                    checked={selectedAddress?._id === addr._id}
                    onChange={() => handleSelectAddress(addr)}
                    className="mt-1 accent-teal-600"
                  />

                  <div>
                    <p className="font-semibold text-gray-800">
                      {addr.fullName}
                    </p>

                    <p className="text-sm text-gray-600">
                      {addr.flatHouse}, {addr.streetArea}
                    </p>

                    <p className="text-sm text-gray-600">
                      {addr.city}, {addr.state} - {addr.pincode}
                    </p>

                    <p className="text-sm text-gray-600">
                      📞 {addr.mobileNumber}
                    </p>

                    {selectedAddress?._id === addr._id && (
                      <span className="inline-block mt-1 text-xs bg-teal-100 text-teal-700 px-2 py-1 rounded-full">
                        ✔ Selected
                      </span>
                    )}
                  </div>
                </div>

                {/* RIGHT BUTTONS */}
                <div className="flex gap-2">
                  <button
                    className="text-xs bg-blue-100 text-blue-600 px-3 py-1 rounded-full hover:bg-blue-200 transition"
                    onClick={(e) => {
                      e.stopPropagation();
                      setFormData(addr);
                      setShowForm(true);
                    }}
                  >
                    ✏️ Edit
                  </button>

                  <button
                    className="text-xs bg-red-100 text-red-600 px-3 py-1 rounded-full hover:bg-red-200 transition"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDelete(addr._id);
                    }}
                  >
                    🗑 Delete
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* FORM */}
      {showForm && (
        <div className="mt-6 border-t pt-5">

          <h3 className="font-semibold mb-4 text-gray-700">
            Add / Edit Address
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {Object.keys(emptyForm).map((key) => (
              <input
                key={key}
                placeholder={key}
                value={formData[key]}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    [key]: e.target.value,
                  })
                }
                className="border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-teal-500"
              />
            ))}

            <button
              onClick={handleSubmit}
              className="md:col-span-2 bg-green-600 text-white py-3 rounded-lg hover:bg-green-700 transition shadow"
            >
              💾 Save Address
            </button>
          </div>
        </div>
      )}
    </div>
  </div>

  {/* MODAL */}
  {showModal && (
    <DeliveryLocationModal
      onClose={() => setShowModal(false)}
      onSelectLocation={handleLocationSelect}
    />
  )}
</div>
  );
};

export default AddressComponent;